<template>
	<SimpleModalComponent
		heading="Choose filters"
		@close-modal="emit( 'close-modal' )"
	>
		<template #content>
			<div class="flex flex--wrap flex--gap-extra-large">
				<ul class="mb-8">
					<template
						v-for="filter, index in dropdown_filter_components"
						:key="`dropdown-filter-${filter.value}`"
					>
						<li v-if="index < dropdown_filter_components.length / 2">
							<label class="checkbox-wrapper">
								<input
									v-model="selection"
									class="checkbox"
									type="checkbox"
									:value="filter.value"
								>
								<span class="checkbox__label">{{ filter.label }}</span>
							</label>
						</li>
					</template>
				</ul>

				<ul class="mb-8">
					<template
						v-for="filter, index in dropdown_filter_components"
						:key="`dropdown-filter-${filter.value}`"
					>
						<li v-if="index >= dropdown_filter_components.length / 2">
							<label class="checkbox-wrapper">
								<input
									v-model="selection"
									class="checkbox"
									type="checkbox"
									:value="filter.value"
								>
								<span class="checkbox__label">{{ filter.label }}</span>
							</label>
						</li>
					</template>
				</ul>
			</div>
		</template>

		<template #buttons>
			<button
				class="button"
				:disabled="loading"
				@click="emit( 'close-modal' )"
			>
				Cancel
			</button>
			<button
				class="button button--fill"
				@click="setSelectedFilters"
			>
				Save
			</button>
		</template>
	</SimpleModalComponent>
</template>

<script setup>
import SimpleModalComponent from './SimpleModalComponent.vue';

import { useDatabaseFiltersStore } from '../../stores/database-filters';
import { useProjectFiltersStore } from '../../stores/project-filters';
import { ref, onMounted, defineEmits, defineProps } from 'vue';
import { storeToRefs } from 'pinia';

const emit = defineEmits( ['close-modal'] );

const props = defineProps( {
	storeKey: {
		type: String,
		default: 'projects',
	}
} );

const filters_store = props.storeKey === 'database' ? useDatabaseFiltersStore() : useProjectFiltersStore();

const {
	setSelectedDropdownFilters,
	removeUnselectedFilters,
	updateQueryStringFromProjectFilters
} = filters_store;

const { dropdown_filter_components } = storeToRefs( filters_store );

const selection = ref( [] );

const setSelectedFilters = () => { // eslint-disable-line snakecasejs/snakecasejs
	setSelectedDropdownFilters( selection.value );
	const active_filters_changed = removeUnselectedFilters();
	if ( active_filters_changed ) {
		updateQueryStringFromProjectFilters();
	}
	emit( 'close-modal' );
};

onMounted( () => {
	selection.value = dropdown_filter_components.value.filter( filter => filter.selected ).map( filter => filter.value );
} );
</script>